





















import {Component, Vue, Watch} from 'vue-property-decorator';
import TrackingTable from '@/screens/dashboard/tracking/TrackingTable.vue';
import {getListTrackingOrders, IFilterTrackingOrder} from '@/services/TrackingOrderService';
import {ITrackingOrder} from '@/models/ITrackingOrder';
import {VPaginationRequestData} from '@/utils/VPaginationRequestData';
import {Debounce} from '@/decorators/DebounceDecorator';
import TrackingOrderStatusSelect from '@/components/TrackingOrderStatusSelect.vue';
import {ModuleShop} from '@/store/modules/ShopModule';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

@Component({
  components: {
    TrackingTable,
    TrackingOrderStatusSelect
  }
})
export default class Tracking extends Vue {
  loading: boolean = true;
  trackings: ITrackingOrder[] = [];

  protected paginationRequestData: VPaginationRequestData<IFilterTrackingOrder> = new VPaginationRequestData({
    query: '',
    status: [],
  });

  updateNewTrackingNumber(trackingNumber: string, trackingId: number) {
    this.trackings.forEach((tracking) => {
      if (tracking.id === trackingId) {
        tracking.tracking_number = trackingNumber;
      }
    });
  }

  get queryStatus() {
    return this.$route.query.status;
  }

  @Watch('routerQuery', {immediate: true, deep: true})
  onStatusChange() {
    if (this.queryStatus) {
      this.paginationRequestData.filterData.status = [String(this.$route.query.status)];
    } else {
      this.paginationRequestData.filterData.status = [];
    }
  }

  @Watch('paginationRequestData.filterData.status', {deep: true})
  @Debounce(500)
  onQueryChange() {
    this.loadData();
  }

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  @Watch('shopId', {immediate: true})
  async loadData() {
    try {
      this.loading = true;
      this.trackings = [];
      this.trackings = await getListTrackingOrders(this.organizationId, this.shopId, this.paginationRequestData);
    } finally {
      this.loading = false;
    }
  }
}
